import React, { useEffect, useState } from "react";
import PageHeaderAlt from "components/layout-components/PageHeaderAlt";
import { Button, Row, Col, Card, Checkbox, message, Modal, Input, Form, Switch, Space } from "antd";
import { PlusOutlined, } from "@ant-design/icons";
import Flex from "components/shared-components/Flex";
import { useNavigate, useParams } from "react-router-dom";
import apiClient from 'services/apiClient';
import { useMyContext } from "Context/MyContextProvider";
import Search from "antd/es/input/Search";
import CommionPermissonsTab from "../Utils/CommionPermissonsTab";
import CommionPermissonsAcc from "../Utils/CommionPermissonsAcc";
import { ErrorExtractor } from "../CustomUtils.js/utils";
import CommionPermissons from "../Utils/CommionPermissons";

const VIEW_LIST = "LIST";
const VIEW_GRID = "GRID";

const ItemHeader = ({ name, category }) => (
    <div>
        <h4 className="mb-0">{name}</h4>
        <span className="text-muted">{category}</span>
    </div>
);

export const PermissionData = async (api, authToken, id) => {
    try {
        const response = await apiClient.get(`${api}role-permission/${id}`, {
            headers: {
                Authorization: "Bearer " + authToken,
            },
        });
        return response.data;
    } catch (error) {
        const err = error.response.data.message || error.response.data.error || "An error occurred while fetching permissions.";
        message.error(err);
    }
};
const RolePermission = () => {
    const { Permisson, api, authToken } = useMyContext()
    const UserPermission = Permisson;
    const { id } = useParams();
    const { role_name } = useParams();

    const [view, setView] = useState('Accordion'); // Set default view
    const [permission, setPermission] = useState([]);
    const [initialPermission, setInitialPermission] = useState([]);
    const [existPermission, setExistPermission] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectAll, setSelectAll] = useState(false);
    const [unChek, setUnChek] = useState(false);
    const navigate = useNavigate();
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
    const handlePermissionChange = (e) => {
        const permissionId = e.target.value;
        const isChecked = e.target.checked;
        if (isChecked) {
            setExistPermission((prevExistpermission) => [
                ...(prevExistpermission || []),
                parseInt(permissionId),
            ]);
        } else {
            const newPermissions = existPermission?.filter(
                (id) => id !== parseInt(permissionId)
            );
            setExistPermission(newPermissions);
        }
    };

    const deleteItem = (id) => {
        const data = permission.filter((elm) => elm.id !== id);
        setPermission(data);
    };

    const fetchPermission = async () => {
        setLoading(true);
        try {
            const data = await PermissionData(api, authToken, id);
            setPermission(data.AllPermission);
            setInitialPermission(data.AllPermission);
            setExistPermission(data.exist);
            setLoading(false);
        } catch (error) {
            message.error(ErrorExtractor(error));
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPermission();
    }, [api, authToken, id]);

    useEffect(() => {
        if (existPermission?.length === permission?.length) {
            setUnChek(true);
        } else {
            setUnChek(false);
        }
    }, [existPermission]);

    useEffect(() => {
        // Check if all checkboxes are checked after the change
        setSelectAll(existPermission?.length === permission?.length);
    }, [existPermission, permission]);
    const handleMultiSelect = (e) => {
        const isChecked = e.target.checked;
        if (isChecked) {
            setSelectAll(true);
            const allPermissionIds = permission.map((p) => p.id);
            setExistPermission(allPermissionIds);
            setUnChek(true);
        } else {
            setSelectAll(false);
            setExistPermission([]);
            setUnChek(false);
        }
    };

    const GivePermission = (e) => {
        setConfirmLoading(true);
        e.preventDefault();
        let ResultData = [...new Set(existPermission)];
        if (ResultData.length > 0) {
            // setBlankError(false);
            apiClient
                .post(
                    `/role-permission/${id}`,
                    {
                        // role_id: parseInt(id),
                        role_id: id,
                        permission_id: ResultData,
                    }
                )
                .then((Response) => {
                    if (Response.data?.status) {
                        message.success("Permission Assign Successfully");
                        setConfirmLoading(false);
                        scrollToTop();
                    }
                })
                .catch((error) => {
                    message.error(ErrorExtractor(error));
                });
        } else {
            message.error("You Have To Select At Least 1 Permission");
            setConfirmLoading(false);
        }
    };

    //model
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [name, setName] = useState('');
    const showModal = () => {
        setOpen(true);
    };
    const handleOk = async () => {
        // setModalText('The modal will be closed after two seconds');
        setConfirmLoading(true);
        try {
            const response = await apiClient.post(`${api}create-permission`, { name }, {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            });
            fetchPermission();
            setConfirmLoading(false);
            handleCancel()
        } catch (error) {
            setConfirmLoading(false);
            handleCancel()
            message.error(ErrorExtractor(error));
        }

    };
    const handleCancel = () => {
        setName("");
        setOpen(false);
    };
    const handleSeach = (e) => {
        const value = e.target.value.toLowerCase();
        if (value) {
            const filteredPermissions = permission.filter(permission =>
                permission.name.toLowerCase().includes(value)
            );
            setPermission(filteredPermissions);
        } else {
            setPermission(initialPermission)
        }
    };

    const HandleView = (value) => {
        setView(value);
    };
    return (
        <>
            <Modal
                title="Create New Permission"
                open={open}
                onOk={handleOk}
                confirmLoading={confirmLoading}
                onCancel={handleCancel}
            >
                <Form.Item label="Name" className=" my-3">
                    <Input type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="permission name"
                    />
                </Form.Item>
            </Modal>
            <PageHeaderAlt className="border-bottom py-2">
                <div className="container-fluid">
                    <Flex
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <h3>Assign Permission to {role_name}</h3>
                        <div>
                            {/* View Toggle Switch */}
                            <Space align="center" style={{ marginRight: 8 }}>
                                <span style={{ fontSize: '14px', color: '#666' }}>
                                    📋 Accordion
                                </span>
                                <Switch
                                    checked={view === 'Tabs'}
                                    onChange={(checked) => HandleView(checked ? 'Tabs' : 'Accordion')}
                                    checkedChildren="📑"
                                    unCheckedChildren="📋"
                                    size="default"
                                />
                                <span style={{ fontSize: '14px', color: '#666' }}>
                                    📑 Tabs
                                </span>
                            </Space>
                            <Button type="primary" className="ml-2" onClick={showModal}>
                                <PlusOutlined />
                                <span>New Permission</span>
                            </Button>
                        </div>
                    </Flex>
                </div>
            </PageHeaderAlt>
            <div className={`my-4 ${view === VIEW_LIST ? "container" : "container-fluid"}`}>
                <Row gutter={16}>
                    <Col xs={24} sm={24} lg={8} xl={8} xxl={6}>
                        <Card>
                            <Flex alignItems="center" justifyContent="space-between">
                                <ItemHeader name={unChek ? "Deselect All" : "Select All"} />
                                <Checkbox
                                    onChange={(e) => handleMultiSelect(e)}
                                    checked={unChek}
                                />
                            </Flex>
                        </Card>
                    </Col>
                    <Col xs={24} sm={24} lg={8} xl={8} xxl={6} />
                    <Col xs={24} sm={24} lg={8} xl={8} xxl={6} />
                    <Col xs={24} sm={24} lg={8} xl={8} xxl={6} className="d-flex justify-content-end">
                        {/* <Card> */}
                        <Flex alignItems="center" justifyContent="space-between">
                            {/* <ItemHeader name={unChek ? "Deselect All" : "Select All"} /> */}
                            <Search placeholder="input search text" onChange={(value) => handleSeach(value)} />
                        </Flex>
                        {/* </Card> */}
                    </Col>
                </Row>
                <CommionPermissons
                    permission={permission}
                    UserPermission={UserPermission}
                    handlePermissionChange={handlePermissionChange}
                    existPermission={existPermission}
                    selectAll={selectAll}
                    view={view}
                />

                <Flex justifyContent="center" alignItems="center" className="py-4">
                    <Button type="primary" danger onClick={() => navigate('/roles')}>Cancel</Button>
                    <Button
                        type="primary"
                        className="ml-2"
                        onClick={(e) => GivePermission(e)}
                        disabled={confirmLoading}
                    >
                        {/* <PlusOutlined /> */}
                        <span>{confirmLoading ? 'Submitting..' : 'Submit'}</span>
                    </Button>

                </Flex>
            </div>
        </>
    );
};

export default RolePermission;
